import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useState } from 'react';
import CopyIcon from '@atlaskit/icon/glyph/copy';
import { FormattedMessage } from 'react-intl-next';
import Action from '../action';
import { messages } from '../../../../../messages';
import { useAnalyticsEvents } from '../../../../../common/analytics/generated/use-analytics-events';
export function CopySummaryAction({
  url,
  onClick: onClickCallback,
  testId,
  content,
  ...props
}) {
  const {
    fireEvent
  } = useAnalyticsEvents();
  const [tooltipMessage, setTooltipMessage] = useState(messages.copy_summary_action_description);
  const handleCopySummaryClick = useCallback(async () => {
    fireEvent('ui.button.clicked.copySummary', {});
    await navigator.clipboard.writeText(content !== null && content !== void 0 ? content : '');
    setTooltipMessage(messages.copied_summary_action_description);
    onClickCallback === null || onClickCallback === void 0 ? void 0 : onClickCallback();
  }, [fireEvent, onClickCallback, content]);
  return /*#__PURE__*/React.createElement(Action, _extends({
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.copy_summary_action)
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
    ,
    icon: /*#__PURE__*/React.createElement(CopyIcon, {
      label: "Copy Summary"
    }),
    onClick: handleCopySummaryClick,
    testId: `${testId}-copy-summary-action`,
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, tooltipMessage),
    tooltipOnHide: () => setTooltipMessage(messages.copy_summary_action_description)
  }, props));
}